import { useRef } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { changePasswordValidate } from "../../config/Validate";
import { postAllData } from "../../service/ProductService";
import { CHANGE_PASSWORD } from "../../config/ApiConstant";

const ChangePassword = () => {
  const toast = useRef<Toast>(null);

  // password submit api call
  const onSubmit = async (values: any, { resetForm, setSubmitting }: any) => {
    try {
      setSubmitting(true);
      const payload = {
        oldPassword: values.currentPassword,
        newPassword: values.newPassword,
        confirmPassword: values.confirmPassword,
      };

      const response = await postAllData(CHANGE_PASSWORD, payload);

      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
        });
        resetForm();
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <AppBreadcrumb
        currentMenu="Change Password"
        pageName="Change Password"
        pageTitle="Change Password"
        goToPage={true}
      />

      <Toast ref={toast} />

      <div
        className="w-full p-4 card shadow-2 border-round-lg"
        style={{ height: "calc(100% - 52px)" }}
      >
        <h2 className="mb-4 text-2xl font-semibold">Change Password</h2>

        <Formik
          initialValues={{
            currentPassword: "",
            newPassword: "",
            confirmPassword: "",
          }}
          validationSchema={changePasswordValidate}
          onSubmit={onSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            resetForm,
            isSubmitting,
          }) => (
            <Form className="p-fluid">
              <div className="grid">
                {/* Current Password */}
                <div className="mb-3 field change_pass col-12 sm:col-6 md:col-4">
                  <label className="block mb-2 font-medium">
                    Current Password
                  </label>
                  <Password
                    toggleMask
                    feedback={false}
                    disabled
                    name="currentPassword"
                    value={values.currentPassword}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter current password"
                    className={
                      touched.currentPassword && errors.currentPassword
                        ? "p-invalid w-full"
                        : "w-full"
                    }
                  />
                  <small className="p-error">
                    <ErrorMessage name="currentPassword" />
                  </small>
                </div>

                {/* New Password */}
                <div className="mb-3 field change_pass col-12 sm:col-6 md:col-4">
                  <label className="block mb-2 font-medium">New Password</label>
                  <Password
                    toggleMask
                    feedback={false}
                    disabled
                    name="newPassword"
                    value={values.newPassword}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter new password"
                    className={
                      touched.newPassword && errors.newPassword
                        ? "p-invalid w-full"
                        : "w-full"
                    }
                  />
                  <small className="p-error">
                    <ErrorMessage name="newPassword" />
                  </small>
                </div>

                {/* Confirm Password */}
                <div className="mb-3 field change_pass col-12 sm:col-6 md:col-4">
                  <label className="block mb-2 font-medium">
                    Confirm New Password
                  </label>
                  <Password
                    toggleMask
                    feedback={false}
                    disabled
                    name="confirmPassword"
                    value={values.confirmPassword}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Confirm new password"
                    className={
                      touched.confirmPassword && errors.confirmPassword
                        ? "p-invalid w-full"
                        : "w-full"
                    }
                  />
                  <small className="p-error">
                    <ErrorMessage name="confirmPassword" />
                  </small>
                </div>
              </div>

              <div className="card-footer">
                <Button
                  label="Clear"
                  className="mr-2 p-button-secondary w-fit"
                  icon="pi pi-times"
                  type="button"
                  disabled
                  onClick={() => resetForm()}
                  // disabled={isSubmitting}
                />
                <Button
                  type="submit"
                  icon="pi pi-check"
                  disabled
                  label="Update Password"
                  className="common-primary-button w-fit"
                  loading={isSubmitting}
                  // disabled={isSubmitting}
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default ChangePassword;
